import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useCart } from "../context/CartContext";
import "./Navbar.css";

const Navbar = ({ onCartClick }) => {
  const { user, userProfile, logout, isAdmin } = useAuth();
  const { getCartCount } = useCart();
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const handleLogout = async () => {
    await logout();
    navigate("/");
    setMenuOpen(false);
  };

  const cartCount = getCartCount();

  const CartIcon = (
    <button
      className="cart-btn"
      onClick={() => { onCartClick(); setMenuOpen(false); }}
      aria-label={cartCount > 0 ? `Cart, ${cartCount} items` : "Cart"}
    >
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="9" cy="21" r="1"></circle>
        <circle cx="20" cy="21" r="1"></circle>
        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
      </svg>
      {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
    </button>
  );

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" onClick={() => setMenuOpen(false)}>
          <span className="logo-icon">☀</span>
          <span className="logo-text">Sunrise Stationery</span>
        </Link>

        {/* Desktop-only nav links */}
        <div className="navbar-links desktop-only">
          <Link to="/" className="nav-link">Home</Link>
          {user && <Link to="/orders" className="nav-link">My Orders</Link>}
          {user && isAdmin && <Link to="/admin" className="nav-link">Admin</Link>}
        </div>

        {/* Desktop-only actions (cart + login/logout) */}
        <div className="navbar-actions desktop-only">
          {CartIcon}
          {user ? (
            <div className="user-menu">
              <Link to="/profile" className="user-name" title="Edit profile">
                {userProfile?.name || user.displayName || "User"}
              </Link>
              <button className="logout-btn" onClick={handleLogout}>Logout</button>
            </div>
          ) : (
            <Link to="/login" className="login-btn">Login</Link>
          )}
        </div>

        {/* Mobile-only: cart + hamburger, always visible together */}
        <div className="navbar-mobile-icons">
          {CartIcon}
          <button
            className="hamburger"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span className={`hamburger-line ${menuOpen ? "open" : ""}`}></span>
            <span className={`hamburger-line ${menuOpen ? "open" : ""}`}></span>
            <span className={`hamburger-line ${menuOpen ? "open" : ""}`}></span>
          </button>
        </div>

        {/* Mobile dropdown panel — single stacked menu, no overlap */}
        <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
          <Link to="/" className="nav-link" onClick={() => setMenuOpen(false)}>Home</Link>
          {user && (
            <Link to="/orders" className="nav-link" onClick={() => setMenuOpen(false)}>My Orders</Link>
          )}
          {user && isAdmin && (
            <Link to="/admin" className="nav-link" onClick={() => setMenuOpen(false)}>Admin</Link>
          )}
          <div className="mobile-menu-divider"></div>
          {user ? (
            <div className="mobile-user-row">
              <Link to="/profile" className="user-name" onClick={() => setMenuOpen(false)}>
                {userProfile?.name || user.displayName || "User"}
              </Link>
              <button className="logout-btn" onClick={handleLogout}>Logout</button>
            </div>
          ) : (
            <Link to="/login" className="login-btn" onClick={() => setMenuOpen(false)}>Login</Link>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;